// Shared revenue-axis scale for the filter sliders (Screener + Map).
//
// A discrete stop ladder rendered over INDICES — each stop gets equal track
// width regardless of value — so the axis is NON-LINEAR: dense small stops +
// sparse large ones give small companies most of the track (the under-€2m band
// is ~14/25 of the slider vs ~2% on a linear €150k–€100m axis). Values are in
// EUR (the €150k platform floor; both sliders filter turnover_eur). First/last
// stop = the floor / ceiling "no-cap" sentinels.
export const REVENUE_STOPS: readonly number[] = [
  150_000, 200_000, 300_000, 400_000, 500_000, 600_000, 700_000, 800_000, 900_000, 1_000_000,
  1_250_000, 1_500_000, 1_750_000, 2_000_000, 3_000_000, 4_000_000, 5_000_000, 7_500_000,
  10_000_000, 15_000_000, 20_000_000, 30_000_000, 50_000_000, 75_000_000, 100_000_000,
];

export const REVENUE_MIN = REVENUE_STOPS[0]!;
export const REVENUE_MAX = REVENUE_STOPS[REVENUE_STOPS.length - 1]!;

/** Index of the stop nearest to a (possibly off-ladder) value. */
export function nearestStopIndex(v: number): number {
  let best = 0;
  let bestD = Infinity;
  for (let i = 0; i < REVENUE_STOPS.length; i++) {
    const d = Math.abs(REVENUE_STOPS[i]! - v);
    if (d < bestD) {
      bestD = d;
      best = i;
    }
  }
  return best;
}

/** Snap a value to the nearest stop. */
export function snapRevenue(v: number): number {
  return REVENUE_STOPS[nearestStopIndex(v)]!;
}
